import { useState, useEffect } from 'react';

export function useNeonFlash(duration = 2500) {
  const [isWhite, setIsWhite] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsWhite(prev => !prev);
    }, duration / 2);
    return () => clearInterval(interval);
  }, [duration]);

  const style = {
    color: isWhite ? '#ffffff' : '#E32510',
    textShadow: isWhite
      ? '0 0 8px rgba(255, 255, 255, 0.6), 0 0 16px rgba(255, 255, 255, 0.3)'
      : '0 0 8px rgba(227, 37, 16, 0.6), 0 0 16px rgba(227, 37, 16, 0.3)',
    transition: 'color 0.8s ease-in-out, text-shadow 0.8s ease-in-out',
  };

  return style;
}
